// Public UI adapted from Klargo-Reference/components/ds/DsLogo.tsx.
import React from 'react';
import klargoLogo from '../../assets/klargo-logo.png';
const INK_BOX = {
    desktop: { width: 79, height: 24 },
    mobile: { width: 66, height: 20 },
};
const SPLIT = 84.4;
const DsLogo = ({ variant = 'desktop', tone = 'onInk', }) => {
    const layer = 'absolute inset-0 h-full w-full object-cover';
    return (<span className="relative block flex-none" style={INK_BOX[variant]}>
      {tone === 'onInk' ? (<>
          
          <img src={klargoLogo} alt="" aria-hidden="true" className={`${layer} brightness-0 invert`} style={{ clipPath: `inset(0 ${100 - SPLIT}% 0 0)` }}/>
          
          <img src={klargoLogo} alt="" aria-hidden="true" className={layer} style={{ clipPath: `inset(0 0 0 ${SPLIT}%)` }}/>
        </>) : (<img src={klargoLogo} alt="" aria-hidden="true" className={layer}/>)}
    </span>);
};
export default DsLogo;
